// Environment-driven endpoints. Deployed builds leave these unset and fall back
// to the serving origin: the vhost reverse-proxies /api (HTTP and the socket at
// /api/socket.io) to the backend, so the app works on whichever host serves it.
// Local development sets explicit localhost values in .env.development.
const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT || `${window.location.origin}/api`
const SOCKET_ENDPOINT = import.meta.env.VITE_SOCKET_ENDPOINT || window.location.origin
const SOCKET_PATH = import.meta.env.VITE_SOCKET_PATH || '/api/socket.io'

export const URLS = {
  BASE_URL: `${API_ENDPOINT}/api/v1`,
  SOCKET_URL: SOCKET_ENDPOINT,
  SOCKET_PATH: SOCKET_PATH,
}
